/*
*
* File JS Principale
*
*/
// IMPORT JQUERY
//--------------------------------------------------------------------//

import $ from 'jquery';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'scss/app.scss';

//--------------------------------------------------------------------//

// Carichiamo i font in maniera asincrona
//--------------------------------------------------------------------//

var Webfont = require('webfontloader');

Webfont.load({
    google: {
        families: ['Cormorant Garamond:400,500', 'Open Sans:400&display=swap']
    }
});


//--------------------------------------------------------------------//

// Libreria Lazysizes
//--------------------------------------------------------------------//
import 'lazysizes';

//--------------------------------------------------------------------//

// Import Utilies
//--------------------------------------------------------------------//

import smoothScroll from './utilities/smooth-scroll';
import initAnimations from './utilities/animations';

//--------------------------------------------------------------------//


// Init Utilies
//--------------------------------------------------------------------//

smoothScroll();

initAnimations();

//--------------------------------------------------------------------//


// Import Componenti
//--------------------------------------------------------------------//

// import initHeader from 'components/header/header';

import footer from 'components/footer/footer';

//--------------------------------------------------------------------//


// Init Componenti
//--------------------------------------------------------------------//

// initHeader();

//--------------------------------------------------------------------//